/* Feedogo: "Follow" a feeder and a "My follows" list.
   Like the other feedogo-*.js patches, this doesn't edit the big section file: it adds to the feeder iframe once it exists.
   - A Follow button in the top-right corner of the live view (desktop and phone).
   - Desktop: "All feeders" / "My follows" tabs on the "Find a feeder" list.
   - Phone/tablet: only the Follow button. The feeder list is hidden there and there is no My follows entry on the live view.
   Follows are saved in this browser (localStorage, key fgFollows), so they work without signing in. Syncing them to the
   customer account across devices would need a small backend endpoint; until then they stay on this device. */
(function () {
  'use strict';
  var FRAME_ID = 'feedogo-feeder-frame';
  var KEY = 'fgFollows';
  var tab = 'all';

  function frame() {
    try {
      var f = document.getElementById(FRAME_ID);
      var w = f && f.contentWindow, d = w && w.document;
      var cam = d && d.querySelector('.camera');
      return cam && typeof w.select === 'function' ? { w: w, d: d, cam: cam } : null;
    } catch (e) { return null; }
  }
  // `stations` is a top-level `let` in the frame, so it isn't a window property; a Function made there can still see it.
  function stations(fr) {
    try { return fr.w.Function('return typeof stations!=="undefined"&&Array.isArray(stations)?stations:[]')(); } catch (e) { return []; }
  }
  function current(fr) { return fr.w.currentStation || null; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v.filter(function (x) { return x && x.code; }) : []; } catch (e) { return []; }
  }
  function store(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function isFollowed(code) { return load().some(function (x) { return x.code === code; }); }
  function toggle(st) {
    var list = load(), i = -1;
    list.forEach(function (x, n) { if (x.code === st.code) i = n; });
    if (i >= 0) list.splice(i, 1); else list.unshift({ code: st.code, name: st.name, at: Date.now() });
    store(list);
    return i < 0;
  }
  // Followed feeders that still exist, live ones first, then in the order they were followed.
  function followed(fr) {
    var all = stations(fr), out = [];
    load().forEach(function (f) {
      for (var i = 0; i < all.length; i++) if (all[i].code === f.code) { out.push({ station: all[i], index: i }); return; }
    });
    return out.sort(function (a, b) { return (b.station.online ? 1 : 0) - (a.station.online ? 1 : 0); });
  }

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3 4.6 13a4.7 4.7 0 0 1 6.6-6.7l.8.8.8-.8a4.7 4.7 0 0 1 6.6 6.7Z"/></svg>';
  var CSS =
    '.fg-top-right{display:flex;align-items:center;gap:8px;margin-left:auto}' +
    '.fg-follow{display:inline-flex;align-items:center;gap:6px;height:34px;padding:0 14px;border:1px solid rgba(255,255,255,.6);border-radius:999px;background:rgba(9,45,39,.72);color:#fff;font:inherit;font-size:13px;font-weight:800;cursor:pointer;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);transition:background .2s,color .2s}' +
    '.fg-follow:hover{background:rgba(9,45,39,.9)}' +
    '.fg-follow svg,.fg-tab svg{width:15px;height:15px;fill:none;stroke:currentColor;stroke-width:2.2;stroke-linejoin:round}' +
    '.fg-follow[aria-pressed="true"]{background:#fff;color:#123f34;border-color:#fff}' +
    '.fg-follow[aria-pressed="true"] svg{fill:#e4573d;stroke:#e4573d}' +
    '.fg-follow.pop svg{animation:fgHeartPop .45s ease}' +
    '@keyframes fgHeartPop{40%{transform:scale(1.35)}100%{transform:scale(1)}}' +
    '.fg-tabs{display:flex;gap:8px;margin-top:16px}' +
    '.fg-tab{display:inline-flex;align-items:center;gap:7px;height:40px;padding:0 16px;border:1px solid #cfddd3;border-radius:999px;background:#fff;color:#52695e;font:inherit;font-size:14px;font-weight:800;cursor:pointer}' +
    '.fg-tab b{min-width:20px;height:20px;padding:0 6px;border-radius:999px;background:#e6f1e9;color:#123f34;font-size:11px;line-height:20px;text-align:center}' +
    '.fg-tab[aria-selected="true"]{background:#123f34;border-color:#123f34;color:#fff}' +
    '.fg-tab[aria-selected="true"] b{background:#d8f36c}' +
    '.fg-tab[aria-selected="true"] svg{fill:#e4573d;stroke:#e4573d}' +
    '.station-browser.fg-mine #stationCards,.station-browser.fg-mine #stationMoreRow{display:none!important}' +
    '#fgFollowCards{display:none}.station-browser.fg-mine #fgFollowCards{display:grid}' +
    '.station-tile .fg-tile-heart{position:absolute;left:5px;bottom:5px;width:20px;height:20px;border-radius:50%;background:#fff;display:grid;place-items:center;box-shadow:0 1px 3px rgba(0,0,0,.2)}' +
    '.station-tile .fg-tile-heart svg{width:12px;height:12px;fill:#e4573d;stroke:#e4573d;stroke-width:2}' +
    '.fg-empty{grid-column:1/-1;border:1px dashed #b9cbbf;border-radius:16px;padding:30px;text-align:center;color:#66796f;font-size:14px;line-height:1.5}' +
    '.fg-empty b{display:block;color:#123f34;font-size:15px;margin-bottom:4px}' +
    '@media(max-width:1024px){' +
    'body[data-page="feed"] .fg-follow{height:28px;padding:0 10px;font-size:11px}' +
    'body[data-page="feed"] .fg-follow svg{width:13px;height:13px}' +
    '}';

  function tileHtml(it, sel) {
    var s = it.station, on = it.index === sel;
    return '<button class="station-tile ' + (on ? 'selected' : '') + '" type="button" data-index="' + it.index + '" aria-pressed="' + on + '">' +
      '<span class="station-thumb"><img loading="lazy" decoding="async" src="' + esc(s.image) + '" alt=""><i class="station-live-dot ' + (s.online ? '' : 'attention') + '"></i><span class="fg-tile-heart">' + HEART + '</span></span>' +
      '<span class="station-copy"><span class="station-code">' + esc(s.code) + '</span><strong>' + esc(s.name) + '</strong><small>' + esc(s.location) + '</small>' +
      '<em>' + (on ? 'Current view' : s.online ? 'Live now' : 'Offline') + '</em></span></button>';
  }
  var EMPTY = '<div class="fg-empty"><b>No follows yet</b>Tap ♡ Follow on a feeder’s live view and it will show up here.</div>';

  function selectedIndex(fr) {
    var cur = current(fr), all = stations(fr);
    for (var i = 0; i < all.length; i++) if (cur && all[i].code === cur.code) return i;
    return -1;
  }
  function codes() { var m = {}; load().forEach(function (x) { m[x.code] = 1; }); return m; }

  function paintButton(fr) {
    var b = fr.d.getElementById('fgFollow'), cur = current(fr);
    if (!b || !cur) return;
    var on = isFollowed(cur.code), label = on ? 'Following' : 'Follow';
    b.setAttribute('aria-pressed', String(on));
    b.setAttribute('aria-label', (on ? 'Unfollow ' : 'Follow ') + cur.name);
    if (b.lastChild.nodeValue !== label) b.lastChild.nodeValue = label;
  }
  function paintBrowser(fr) {
    var sec = fr.d.getElementById('stations');
    if (!sec) return;
    var mine = followed(fr), sel = selectedIndex(fr), follows = codes();
    var n = fr.d.getElementById('fgMineCount'); if (n) n.textContent = mine.length;
    var a = fr.d.getElementById('fgAllCount'); if (a) a.textContent = stations(fr).length;
    sec.classList.toggle('fg-mine', tab === 'mine');
    Array.prototype.forEach.call(sec.querySelectorAll('.fg-tabs .fg-tab'), function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-tab') === tab)); });
    var box = fr.d.getElementById('fgFollowCards');
    if (box) {
      var html = mine.length ? mine.map(function (it) { return tileHtml(it, sel); }).join('') : EMPTY;
      if (box.getAttribute('data-html') !== html) { box.setAttribute('data-html', html); box.innerHTML = html; }
    }
    // Small heart on followed feeders in the full list.
    Array.prototype.forEach.call(fr.d.querySelectorAll('#stationCards .station-tile'), function (t) {
      var code = (t.querySelector('.station-code') || {}).textContent, has = t.querySelector('.fg-tile-heart');
      if (follows[code] && !has) { var th = t.querySelector('.station-thumb'); if (th) th.insertAdjacentHTML('beforeend', '<span class="fg-tile-heart">' + HEART + '</span>'); }
      else if (!follows[code] && has) has.remove();
    });
  }
  function paint(fr) { paintButton(fr); paintBrowser(fr); }

  function setup(fr) {
    var d = fr.d;
    if (!d.getElementById('fgFollowCss')) { var st = d.createElement('style'); st.id = 'fgFollowCss'; st.textContent = CSS; d.head.appendChild(st); }
    if (fr.cam.getAttribute('data-fg-follow')) return;
    fr.cam.setAttribute('data-fg-follow', '1');

    // Follow button, top-right of the live view (the room counter, shown on phones, sits next to it).
    var top = fr.cam.querySelector('.camera-top');
    if (top) {
      var right = d.createElement('div'); right.className = 'fg-top-right';
      right.innerHTML = '<button type="button" class="fg-follow" id="fgFollow" aria-pressed="false">' + HEART + 'Follow</button>';
      var counter = d.getElementById('mobileRoomCounter');
      if (counter && counter.parentNode === top) { top.insertBefore(right, counter); right.appendChild(counter); } else top.appendChild(right);
      d.getElementById('fgFollow').addEventListener('click', function () {
        var cur = current(fr); if (!cur) return;
        var on = toggle(cur), b = this;
        b.classList.remove('pop'); if (on) { void b.offsetWidth; b.classList.add('pop'); }
        paint(fr);
      });
    }

    // Desktop: tabs above the feeder list.
    var row = d.querySelector('#stations .station-title-row'), cards = d.getElementById('stationCards');
    if (row && cards) {
      row.insertAdjacentHTML('afterend', '<div class="fg-tabs" role="tablist" aria-label="Feeders">' +
        '<button type="button" class="fg-tab" role="tab" data-tab="all" aria-selected="true">All feeders <b id="fgAllCount">0</b></button>' +
        '<button type="button" class="fg-tab" role="tab" data-tab="mine" aria-selected="false">' + HEART + 'My follows <b id="fgMineCount">0</b></button></div>');
      cards.insertAdjacentHTML('afterend', '<div class="stations" id="fgFollowCards"></div>');
      d.querySelector('#stations .fg-tabs').addEventListener('click', function (e) {
        var t = e.target.closest('[data-tab]'); if (!t) return;
        tab = t.getAttribute('data-tab'); paint(fr);
      });
      d.getElementById('fgFollowCards').addEventListener('click', function (e) {
        var b = e.target.closest('button[data-index]');
        if (b) fr.w.select(Number(b.getAttribute('data-index')), true);
      });
      new fr.w.MutationObserver(function () { paintBrowser(fr); }).observe(cards, { childList: true });
    }

    fr.w.addEventListener('stationchange', function () { paint(fr); });
    // Another tab may have followed or unfollowed.
    window.addEventListener('storage', function (e) { if (e.key === KEY) paint(fr); });
    paint(fr);
  }

  setInterval(function () {
    var fr = frame();
    if (!fr) return;
    setup(fr);
    paintButton(fr);
  }, 1000);
})();
